import { render, staticRenderFns } from "./RewardsScreen.vue?vue&type=template&id=5951b28c&scoped=true&"
import script from "./RewardsScreen.vue?vue&type=script&lang=js&"
export * from "./RewardsScreen.vue?vue&type=script&lang=js&"
import style0 from "./RewardsScreen.vue?vue&type=style&index=0&id=5951b28c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5951b28c",
  null
  
)

export default component.exports